import { StyleSheet } from 'react-native';
import { BG_COLOR, GREY_COLOR, BLACK_COLOR } from '../../../shared/constants/ColorConstants';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: BG_COLOR,
  },
  mainContainer: {
    flex: 1,
  },
  top: {
    height: '35%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  infoContainer: {
    flex: 1,
    paddingHorizontal: 25,
  },
  buttonContainer: {
    backgroundColor: 'rgb(127, 192, 66)',
    paddingVertical: 15,
    borderRadius: 10,
  },
  forgetButton: {
    marginVertical: 20,
    alignItems: 'center',
  },
  forgetText: {
    color: GREY_COLOR,
    fontSize: 18,
  },
  bottomContainer: {
    backgroundColor: 'rgb(138, 138, 138)',
    paddingVertical: 12,
    height: 50,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  buttonTextBold: {
    // textAlign: "center",
    color: 'rgb(255, 255, 255)',
    fontWeight: 'bold',
    fontSize: 18,
    // backgroundColor: "red"
  },
  buttonText: {
    textAlign: 'center',
    color: 'rgb(255, 255, 255)',
    fontSize: 16,
  },
  textInput: {
    height: 44,
    width: '100%',
    alignSelf: 'flex-start',
    color: BLACK_COLOR,
    fontSize: 14,
    padding: 12,
    backgroundColor: 'rgb(241, 242, 243)',
    borderRadius: 7,
  },
});
